<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl">
        <div v-if="isSent" class="flex flex-col align-center items-center h-full">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-20 w-20 animate-bounce text-indigo-400"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M3 7h3"></path>
                <path d="M3 11h2"></path>
                <path
                    d="M9.02 8.801l-.6 6a2 2 0 0 0 1.99 2.199h7.98a2 2 0 0 0 1.99 -1.801l.6 -6a2 2 0 0 0 -1.99 -2.199h-7.98a2 2 0 0 0 -1.99 1.801z"
                ></path>
                <path d="M9.8 7.5l2.982 3.28a3 3 0 0 0 4.238 .202l3.28 -2.982"></path>
            </svg>

            <div>
                {{ $t('messages.sent') }}
            </div>
        </div>
        <form :action="widget.content.url" method="post" @submit.prevent="submit" v-else>
            <div class="flex justify-between gap-x-2">
                <label v-for="i in 4" :key="i">
                    <input type="radio" name="mood_score" :value="i" class="sr-only" v-model="form.mood_score" />
                    <SmileyPollEmojiImage
                        :number="i"
                        class="h-20 w-20 cursor-pointer"
                        :class="{ 'opacity-50': form.mood_score !== i }"
                    />
                </label>
            </div>
            <FormError :value="form.errors.mood_score" class="mt-2" />
            <div class="mt-5">
                <FormLabel :value="$t('messages.do_you_want_to_say_something?')" for="comment" />
                <div class="">
                    <FormTextarea
                        id="description"
                        v-model="form.comment"
                        name="comment"
                        class="mt-1 min-h-full"
                        style="min-height: 40px"
                    />
                </div>
                <FormError :value="form.errors.comment" class="mt-2" />
            </div>
            <div class="flex justify-between mt-5">
                <div>
                    <div class="text-indigo-500 text-sm" v-if="!form.mood_score">
                        {{ $t('messages.mood_score_required') }}
                    </div>
                </div>
                <SubmitFormButton :button-text="$t('messages.send')" :processing="form.processing" />
            </div>
        </form>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import SmileyPollEmojiImage from '@/components/SmileyPollEmojiImage.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    name: 'MoodCheckWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        BaseWidget,
        FormTextarea,
        FormLabel,
        FormError,
        SmileyPollEmojiImage,
        SubmitFormButton,
    },
    data() {
        return {
            form: this.$inertia.form({
                comment: null,
                mood_score: null,
            }),
            isSent: false,
        };
    },
    methods: {
        submit() {
            this.form.post(this.widget.content.url, {
                preserveScroll: true,
                onSuccess: () => {
                    this.isSent = true;
                },
            });
        },
    },
};
</script>
